import styles from './HeaderTop.module.scss';

export interface HeaderTopProps {
	children: React.ReactNode;
}

export const HeaderTop = ({ children }: HeaderTopProps) => {
	return <div className={styles.HeaderTop}>{children}</div>;
};
